export default "__VITE_ASSET__B0QsP$1$__"